import React from 'react'
import { Theme } from '@pga/pga-component-library'
import { H1, FlexCol, Title, Description, Btn, ButtonContainer, Link } from './styles'
import { withRouter } from 'react-router-dom'
import { useModal } from './ModalContext'

const GetStartedButton = () => {
  const { openModal } = useModal()

  return (
    <Btn onClick={() => openModal('prospect')} data-testid='get-started'>Get Started</Btn>
  )
}

export const PathToMembership = ({ history }) => {
  return (
    <FlexCol>
      <H1 color={Theme.colors.primary}>PATH TO MEMBERSHIP</H1>
      <Title>Expand your career and grow the game you love</Title>
      <Description>By becoming a PGA of America Member, you can fully immerse yourself in the world of golf, forge a fulfilling career, and actively contribute to the sport's growth and development. Join a network of over 30,000 recognized golf industry leaders worldwide and embrace a multitude of benefits that come with PGA of America Membership today.</Description>
      <ButtonContainer>
        <GetStartedButton />
        <Link href='https://pga.org/membership' name='learn-more' target='_blank' rel='noreferrer'>Learn More &rarr;</Link>
      </ButtonContainer>
    </FlexCol>
  )
}

export default withRouter(PathToMembership)
